<template>
  <div>
    <div class="top">
      <div class="logo">
        <div class="logo-left">
          <img src="@/assets/png/home/logo.png" alt="" />
        </div>
        <div class="logo-right">
          <p style="font-size: 30px; font-weight: bold">{{ title }}</p>
          <p style="font-size: 20px">www.zhzqw.cn</p>
        </div>
      </div>
      <div class="tab">
        <div class="box" @click="homePage">首页</div>
        <div class="box" @click="noticeClick">通知</div>
        <!-- <div class="box">组织</div> -->
        <div class="box" @click="enterpriseClick">企业</div>
        <div class="box actives">族谱</div>
        <div class="box" @click="ancestryClick">家谱树</div>
        <!-- <div class="box">宗亲分布</div> -->
        <!-- <div class="box" @click="$router.push('./celebrity')">名人</div>
        <div class="box" @click="$router.push('./culture')">文化典故</div>
        <div class="box" @click="$router.push('./merit')">功德</div> -->
      </div>
    </div>
    <div class="banner">
      <img src="@/assets/png/home/banner.png" alt="" />
    </div>
    <div class="content">
      <div class="content-con">
        <div class="left"></div>
        <div class="right"></div>
      </div>
      <div class="con">
        <div class="mune" :style="{ height: catalogHeight + 'px' }">
          <div class="mune-top">目录</div>

          <template v-for="(g, gi) in displayGenealogyList">
            <div v-if="g.volumes" class="mune-group-title" :key="'g-' + gi" @click="onGroupTitleClick(g, gi)">
              <span class="arrow" v-if="hasVolumes(g)" :class="{ open: expandedMap[gi] }">▶</span>
              <span class="arrow placeholder" v-else></span>
              <span class="g-name" :title="g.familyTreeName">{{ g.familyTreeName }}</span>
              <span v-if="!hasVolumes(g)" class="g-tag">暂无</span>
            </div>
            <div class="vol-wrap" :key="'vol-' + gi" v-if="hasVolumes(g) && expandedMap[gi]">
              <div v-for="(v, vi) in g.volumes" :key="gi + '-' + vi" class="mune-sub-item"
                :class="{ 'mune-item-active': activeKey === gi + '-' + vi }" @click="letterClcik(g, v, gi, vi)">
                {{ v.label }}
              </div>
            </div>
          </template>
          <div v-if="displayGenealogyList.length === 0" class="mune-empty">暂无</div>
        </div>
        <div class="surname">
          <div class="top2">{{ activeFamilyTreeName || '族谱' }}<span v-if="activeVolumeLabel" class="vol-tag">{{
              activeVolumeLabel }}</span></div>
          <div class="surname-body">
            <template v-if="childrenList && childrenList.length">
              <div class="con1" v-for="(item, index) in childrenList" :key="index">
                <p>{{ item.label }}</p>
                <!-- <router-link style="cursor: pointer; z-index: 999" :to="{
                  path: './preview',
                  query: {
                    pdf: item.value,
                  },
                }" target="_blank">
                  预览
                </router-link> -->

                <span style="cursor: pointer; z-index: 999; color: #409EFF" @click="handlePreview(item)">预览</span>
              </div>
            </template>
            <div v-else class="empty-tip">暂无族谱内容</div>
          </div>
          <div class="bottom">
          </div>
        </div>
      </div>
    </div>
    <div class="foot">
      <div class="e">
        <div class="left2">
          <img src="@/assets/png/home/logo.png" alt="" />
        </div>
        <div class="right2">
          <p>版权所有:&nbsp;&nbsp;安徽图腾传承文化有限公司</p>
          <div style="display: flex">
            <p>客服电话:&nbsp;&nbsp;18963782919</p>
            <p style="margin-left: 20px">
              企业邮箱:&nbsp;&nbsp;zhzqwvip@163.com
            </p>
          </div>
          <div style="display: flex">
            <p>备案号:&nbsp;&nbsp;<a href="https://beian.miit.gov.cn/#/Integrated/index"
                target="_blank">皖ICP备1833721395-1号</a>
            </p>
            <p style="margin-left: 20px">
              公安备案:&nbsp;&nbsp;皖公网安备 34019202000232号
            </p>
            <!-- <p style="margin-left: 20px">编委会管理中心</p> -->
            <a href="https://client.zqyp.net/" target="_blank" style="margin-left: 20px">编委会管理中心</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Message } from 'element-ui';
  import { PORT_TYPE_CODE } from "@/constant/constant";
  export default {
    data() {
      return {

        title: "",

        childrenList: [],

        genealogyList: [],

        // 含 volumes 的族谱（左侧目录展示）
        displayGenealogyList: [],
        // 各族谱组的展开状态 { 0: true, 1: false }
        expandedMap: {},
        // 当前选中的卷册 key  ("gi-vi")
        activeKey: "",
        activeFamilyTreeName: "",
        activeVolumeLabel: "",

        pageSize: 12,
        // 总数
        total: 0,
        familyTreeId: "",

        // 目录高度
        catalogHeight: 50,

        name: "",
      };
    },

    created() {
      var params = new URLSearchParams(window.location.search);
      // 获取参数值
      this.familyTreeId = params.get("familyTreeId");
      this.name = params.get("name");
      this.title = JSON.parse(this.$Base64.decode(params.get("name")));
      // 族谱
      this.getGenealogy();
    },
    // instance1
    methods: {
      // 首页
      homePage() {
        this.$router.push({
          path: "./editorialBoard",
          query: {
            familyTreeId: this.familyTreeId,
            name: this.name,
          },
        });
      },

      // 通知
      noticeClick() {
        this.$router.push({
          path: "./ancestorsdetalis",
          query: {
            familyTreeId: this.familyTreeId,
            name: this.name,
          },
        });
      },

      // 企业
      enterpriseClick() {
        this.$router.push({
          path: "./enterprise",
          query: {
            familyTreeId: this.familyTreeId,
            name: this.name,
          },
        });
      },

      // 家谱树
      ancestryClick() {
        this.$router.push({
          path: "./tree",
          query: {
            familyTreeId: this.familyTreeId,
            name: this.name,
          },
        });
      },

      handleSizeChange(val) {
        this.currentPage = val;
        this.getFamilyFirm();
        console.log(val, "val");
      },

      handlePreview(item) {
        if (!item.imgs?.length) {
          Message.warning('当前册未配置预览地址')
          return
        }
        const key = 'preview_imgs_' + Date.now()
        sessionStorage.setItem(key, JSON.stringify(item.imgs))
        const routeUrl = this.$router.resolve({
          path: './preview',
          query: { key }
        })
        window.open(routeUrl.href, '_blank')
      },

      hasVolumes(g) {
        return Array.isArray(g.volumes) && g.volumes.length > 0;
      },

      onGroupTitleClick(g, gi) {
        if (this.hasVolumes(g)) {
          this.$set(this.expandedMap, gi, !this.expandedMap[gi]);
        } else {
          // 无 volumes 数据时点击：右侧只切换标题
          this.activeKey = "";
          this.activeFamilyTreeName = g.familyTreeName || "族谱";
          this.activeVolumeLabel = "";
          this.childrenList = [];
        }
        this.recalcCatalogHeight();
      },



      letterClcik(g, v, gi, vi) {
        this.activeKey = gi + '-' + vi;
        this.activeFamilyTreeName = g.familyTreeName || "族谱";
        this.activeVolumeLabel = v.label || "";
        this.childrenList = v.children || [];
      },

      recalcCatalogHeight() {
        let h = 50;
        this.displayGenealogyList.forEach((g, gi) => {
          if (!g.volumes) {
            return;
          }
          h += 50;
          if (this.expandedMap[gi]) {
            h += (g.volumes ? g.volumes.length : 0) * 50;
          }
        });
        this.catalogHeight = h;
      },

      // 族谱
      async getGenealogy() {
        var params = new URLSearchParams(window.location.search);
        var familyTreeId = params.get("familyTreeId");
        let res = await this.$api.getFamilyTreeFile(JSON.parse(this.$Base64.decode(familyTreeId)))
        console.log('res', res);

        this.genealogyList = res.data || [];

        // 全部族谱都展示在左侧目录（即使 volumes 为 null）
        this.displayGenealogyList = this.genealogyList;

        // 含 volumes 的默认展开
        const map = {};
        this.displayGenealogyList.forEach((g, i) => {
          map[i] = this.hasVolumes(g);
        });
        this.expandedMap = map;

        // 默认选中第一本含 volumes 的族谱第一卷
        const firstIdx = this.displayGenealogyList.findIndex((g) => this.hasVolumes(g));
        if (firstIdx >= 0) {
          const first = this.displayGenealogyList[firstIdx];
          this.letterClcik(first, first.volumes[0], firstIdx, 0);
        } else {
          this.activeFamilyTreeName = (this.displayGenealogyList[0] && this.displayGenealogyList[0].familyTreeName) || "族谱";
          this.activeVolumeLabel = "";
          this.childrenList = [];
        }
        this.recalcCatalogHeight();
      }


    },
    
  };
</script>

<style scoped>
  .actives {
    border-bottom: 2px solid #bf1c29;
  }

  .surname {
    width: 80%;
    height: 1000px;
    background-color: #fff;
  }

  .top2 {
    width: 100%;
    height: 50px;
    border-bottom: 2px solid #bf1c29;
    font-size: 20px;
    padding-left: 27px;
    color: #333333;
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }

  .surname-body {
    width: 100%;
    height: calc(100% - 52px - 131px);
    padding: 50px 67px 131px 40px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }

  .con1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;
    padding: 14px 20px;
    background-color: #fafafa;
    border-left: 4px solid #bf1c29;
    border-radius: 4px;
    font-size: 16px;
    color: #333;
  }

  .con1 a {
    color: #bf1c29;
    text-decoration: none;
    font-size: 14px;
    padding: 4px 14px;
    border: 1px solid #bf1c29;
    border-radius: 4px;
    transition: all 0.2s;
  }

  .con1 a:hover {
    background: #bf1c29;
    color: #fff;
  }

  .mune-item-active {
    background: linear-gradient(to right, rgba(194, 37, 45, 0.12), rgba(253, 195, 0, 0.12));
    color: #bf1c29;
    font-weight: bold;
  }

  .mune {
    position: relative;
    z-index: 9999;
  }

  .vol-wrap {
    width: 100%;
    position: relative;
    z-index: 9999;
  }

  .mune-group-title {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    padding: 0 14px;
    box-sizing: border-box;
    cursor: pointer;
    font-size: 15px;
    color: #333;
    font-weight: bold;
    border-bottom: 1px solid #f1f1f1;
    user-select: none;
    position: relative;
    z-index: 9999;
  }

  .mune-group-title:hover {
    background-color: #fafafa;
  }

  .mune-group-title .arrow {
    display: inline-block;
    width: 12px;
    margin-right: 8px;
    font-size: 10px;
    color: #999;
    transition: transform 0.2s;
  }

  .mune-group-title .arrow.placeholder {
    visibility: hidden;
  }

  .mune-group-title .arrow.open {
    transform: rotate(90deg);
  }

  .mune-group-title .g-name {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .mune-group-title .g-tag {
    flex-shrink: 0;
    font-size: 12px;
    color: #c2c2c2;
    font-weight: normal;
  }

  .mune-sub-item {
    width: 100%;
    height: 50px;
    line-height: 50px;
    padding: 0 14px 0 40px;
    box-sizing: border-box;
    text-align: left;
    font-size: 14px;
    color: #555;
    cursor: pointer;
    position: relative;
    z-index: 9999;
    border-bottom: 1px solid #f5f5f5;
  }

  .mune-sub-item:hover {
    background-color: #fafafa;
  }

  .vol-tag {
    margin-left: 12px;
    font-size: 14px;
    font-weight: normal;
    color: #999;
  }

  .vol-fade-enter-active,
  .vol-fade-leave-active {
    transition: all 0.2s ease;
  }

  .vol-fade-enter,
  .vol-fade-leave-to {
    opacity: 0;
    transform: translateY(-4px);
  }

  .mune-empty,
  .empty-tip {
    width: 100%;
    text-align: center;
    color: #999;
    font-size: 14px;
    padding: 30px 0;
  }

  .bottom {
    width: 100%;
    height: 131px;

    display: flex;
    align-items: center;
    padding-left: 40px;
  }

  .box2 {
    padding: 10px;
    border: 1px solid #c2c2c2;
    margin-bottom: 20px;
  }

  .mune {
    width: 15%;
    background-color: #fff;
  }

  .mune-top {
    width: 100%;
    height: 50px;
    background: linear-gradient(to right, rgb(194, 37, 45), rgb(253, 195, 0));
    font-size: 20px;
    color: #fff;
    text-align: center;
    line-height: 50px;
  }

  .mune-item {
    width: 100%;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 15px;
    position: relative;
  }

  .mune-item div {
    width: 5px;
    height: 17px;
    position: absolute;
    top: 16px;
    left: 25px;
  }

  .active {
    background-color: rgb(194, 37, 45);
  }

  * {
    margin: 0;
    padding: 0;
  }

  body {
    background-color: #f8f8f8;
  }

  .top {
    width: 100%;
    height: 145px;
    background: url(@/assets/png/home/top.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .top .logo {
    /* width: 14%; */
    height: 73px;
    display: flex;
    align-items: center;
  }

  .logo>.logo-left>img {
    width: 100%;
    height: 100%;
  }

  .logo-left {
    width: 50px;
    height: 66px;
  }

  .logo-right {
    display: flex;
    flex-direction: column;
    margin-left: 12px;
  }

  .top .tab {
    /* width: 50%; */
    width: 24%;
    display: flex;
    justify-content: space-between;
  }

  .top .tab .box {
    /* font-family: MicrosoftYaHei;
  font-size: 20px;
  color: #000000;
  font-weight: 500; */
    cursor: pointer;
    height: 35px;
    font-family: MicrosoftYaHei;
    font-size: 20px;
    color: #000000;
    font-weight: bold;
  }

  .banner {
    width: 100%;
    height: 400px;
  }

  .banner img {
    width: 100%;
    height: 100%;
  }

  .content {
    width: 100%;
    height: calc(1996px - 645px - 161px);
    position: relative;
  }

  .content .content-con {
    position: absolute;
    left: 16%;
    width: 67%;
    height: calc(1996px - 645px - 161px);
    display: flex;
  }

  .content .content-con .left {
    width: 50%;
    height: calc(1996px - 645px - 161px - 280px);
    background: url(@/assets/png/home/left.png) no-repeat;
    background-size: 100% 100%;
    margin-top: 50px;
    margin-bottom: 230px;
    z-index: 22;
  }

  .content .content-con .right {
    width: 50%;
    height: calc(1996px - 645px - 161px - 280px);
    background: url(@/assets/png/home/right.png) no-repeat;
    background-size: 100% 100%;
    margin-top: 280px;
    z-index: 22;
  }

  .con {
    width: 67%;
    height: calc(1996px - 645px - 161px);

    margin: 0 auto;
    padding-top: 50px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
  }

  .top1 {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 25px;
    justify-content: space-between;
    position: relative;
  }

  .xian2 {
    width: 88%;
    height: 1px;
    background-color: #dddddd;
  }

  .more {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 12px;
    color: #c2c2c2;
  }

  .e {
    width: 62%;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .left2 {
    width: 15%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .right2 {
    width: 85%;
    height: 60%;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }

  .foot {
    width: 100%;
    height: 161px;
    background-image: url(@/assets/png/home/bottom.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding-left: 20%;
    box-sizing: border-box;
  }
</style>